import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link, Route, Switch, withRouter } from 'react-router-dom';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import { AdminCategories, AdminCategoryDetails } from '../Categories';
import { AdminContractorDetails, AdminContractors } from '../Contractors';
import { DynamicFieldListDetails, DynamicFieldLists } from '../DynamicFieldLists';
import { AdminExpenseTypeDetails, AdminExpenseTypes } from '../ExpenseTypes';
import AdminGroupEmail from '../GroupEmail/AdminGroupEmail';
import { AdminOperatorDetails, AdminOperators } from '../Operators';
import { AdminProductDetails, AdminProducts } from '../Products';
import { AdminRegionProductDetails } from '../Products/AdminRegionProductDetails';
import AdminRoleDetails from '../Roles/AdminRoleDetails';
import AdminRoles from '../Roles/AdminRoles';
import { AdminSolidsControlEquipDetails, AdminSolidsControlEquips } from '../SolidsControlEquips';
import AdminTaxRates from '../TaxRates/AdminTaxRates';
import { AdminUserDetails, AdminUsers } from '../Users';
import { AdminWarehouseDetails, AdminWarehouses } from '../Warehouses';
import './Dashboard.scss';

@inject('stores')
@observer
class AdminDashboard extends React.Component {
    public props: any;
    private UserStore: UserStore;
    private WellsStore: WellsStore;
    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.WellsStore = props.stores.WellsStore;
    }

    public componentDidMount() {
        this.UserStore.getProfile()
            .then(() => {
                if(!this.UserStore.hasPermission('Permissions.Admin.View')) {
                    this.props.history.push('/home');
                }
            })
            .catch(() => {
                this.props.history.push('/home');
            });
        this.WellsStore.clearWell();
    }

    public isSelected(task: string) {
        if (this.props.match.params.task === task) {
            return 'selected';
        }

        return '';
    }

    public render() {
        return(
            <div className="AdminDashboard">
                <div className="row header">
                    <h1>Admin Dashboard</h1>
                </div>
                <div>
                    <div className="row">
                        <div className="col-12">
                            <ul className="dashboard-options-small">
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.Roles.Read') &&
                                <li className={this.isSelected('roles')}><Link to='/admin/roles'>Roles</Link></li>
                                }
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.Users.Read') &&
                                <li className={this.isSelected('users')}><Link to='/admin/users'>Users</Link></li>
                                }
                                {
                                    ( this.UserStore.hasPermission('Permissions.Admin.Inventory.Read') ||
                                        this.UserStore.hasPermission('Permissions.Admin.RegionInventory.Read')) &&
                                <li className={this.isSelected('products')}><Link to='/admin/products'>Inventory</Link></li>
                                }
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.Categories.Read') &&
                                <li className={this.isSelected('categories')}><Link to='/admin/categories'>Categories</Link></li>
                                }
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.Operators.Read') &&
                                    <li className={this.isSelected('operators')}><Link to='/admin/operators'>Operators</Link></li>
                                }
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.Contractors.Read') &&
                                    <li className={this.isSelected('contractors')}><Link to='/admin/contractors'>Contractors</Link></li>
                                }
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.OptionalFieldLists.View') &&
                                    <li className={this.isSelected('fieldlists')}><Link to='/admin/fieldlists'>Optional Field Lists</Link></li>
                                }
                                { 
                                    this.UserStore.hasPermission('Permissions.Admin.Warehouses.Read') &&
                                    <li className={this.isSelected('warehouses')}><Link to='/admin/warehouses'>Warehouses</Link></li>
                                }
                                {
                                    this.UserStore.hasPermission('Permissions.Admin.SolidEquip.Read') &&
                                    <li className={this.isSelected('solidsControlEquips')}><Link to='/admin/solidsControlEquips'>Solids Equipment</Link></li>
                                }
                                {
                                    this.UserStore.hasPermission('Permissions.Admin.InternalEmails.Read') &&
                                    <li className={this.isSelected('groupemails')}><Link to='/admin/groupemails'>Internal Emails</Link></li>
                                }
                                {
                                    this.UserStore.hasPermission('Permissions.Admin.TaxRates.Read') &&
                                    <li className={this.isSelected('taxrates')}><Link to='/admin/taxrates'>Tax Rates</Link></li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Switch>
                                <Route exact={true} path="/admin/roles" component={AdminRoles} />
                                <Route exact={true} path="/admin/roles/:id" component={AdminRoleDetails} />
                                <Route exact={true} path="/admin/users" component={AdminUsers} />
                                <Route exact={true} path="/admin/users/:userName" component={AdminUserDetails} />
                                <Route exact={true} path="/admin/categories" component={AdminCategories} />
                                <Route exact={true} path="/admin/categories/:id" component={AdminCategoryDetails} />
                                <Route exact={true} path="/admin/products" component={AdminProducts} />
                                <Route exact={true} path="/admin/products/:id" component={AdminProductDetails} />
                                <Route exact={true} path="/admin/regions/:id" component={AdminRegionProductDetails} />
                                <Route exact={true} path="/admin/operators" component={AdminOperators} />
                                <Route exact={true} path="/admin/operators/:id" component={AdminOperatorDetails} />
                                <Route exact={true} path="/admin/contractors" component={AdminContractors} />
                                <Route exact={true} path="/admin/contractors/:id" component={AdminContractorDetails} />
                                <Route exact={true} path="/admin/warehouses" component={AdminWarehouses} />
                                <Route exact={true} path="/admin/warehouses/:id" component={AdminWarehouseDetails} />
                                <Route exact={true} path="/admin/expenseTypes" component={AdminExpenseTypes} />
                                <Route exact={true} path="/admin/expenseTypes/:id" component={AdminExpenseTypeDetails} />
                                <Route exact={true} path="/admin/solidsControlEquips" component={AdminSolidsControlEquips} />
                                <Route exact={true} path="/admin/solidsControlEquips/:id" component={AdminSolidsControlEquipDetails} />
                                <Route exact={true} path="/admin/fieldlists" component={DynamicFieldLists} />
                                <Route exact={true} path="/admin/fieldlists/:id" component={DynamicFieldListDetails} />
                                <Route exact={true} path="/admin/groupemails" component={AdminGroupEmail} />
                                <Route exact={true} path="/admin/taxrates" component={AdminTaxRates} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AdminDashboard);


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Dashboard/Dashboard.tsx